import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=7d6ef2b7"
import script from "./GeneralTab.vue?vue&type=script&lang=js"
export * from "./GeneralTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralTab.vue?vue&type=style&index=0&id=7d6ef2b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports